// ignore-string-externalization
import React from 'react';
import storage from 'local-storage-fallback';
import { useRouter } from 'next/router';
import { useCurrentUser } from '../../@mrkt/useCurrentUser';
import { pageView as gaPageView, setDimension, setUserId } from './ga';
import { createFrodorPageView } from '@spotify-internal/event-definitions/es5/events/createFrodorPageView';
import { createFrodorPageViewNonAuth } from '@spotify-internal/event-definitions/es5/events/createFrodorPageViewNonAuth';
import { logGabitoEvent, logNonAuthGabitoEvent } from '@mrkt/features/gabito';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var Track = function Track(_ref) {
  var children = _ref.children;
  var router = useRouter();
  var lastPathname = React.useRef(null);
  var pathname = router.asPath;
  var user = useCurrentUser();
  React.useEffect(function () {
    var href = true ? window.location.href : pathname;
    var gabitoEvent = {};

    if (user) {
      var _user$partnerIds;

      var partnerId = (_user$partnerIds = user.partnerIds) === null || _user$partnerIds === void 0 ? void 0 : _user$partnerIds.google;

      if (partnerId) {
        setUserId(partnerId);
      }

      setDimension(1, 'external'); // TODO: check isEmployee flag after merging to mrkt-web

      setDimension(2, 'isNotFive');
      setDimension(3, user.hasAccess ? 'Yes' : 'No'); // see if we can grab the last visited artist ID from the backdoor

      var artistId;

      if (user.username) {
        artistId = storage.getItem("".concat(user.username, ":analytics:lastVisitedArtist"));
        setDimension(4, artistId);
      }

      gabitoEvent = createFrodorPageView({
        url: href,
        pathname: pathname,
        title: document.title,
        partner_id: partnerId,
        is_employee: null,
        has_access: user.hasAccess,
        artist_id: artistId
      });
    } else if (user === null) {
      gabitoEvent = createFrodorPageViewNonAuth({
        url: href,
        pathname: pathname,
        title: document.title
      });
    }

    if (user !== undefined) {
      if (pathname !== lastPathname.current) {
        lastPathname.current = pathname; // fire gabito event

        if (user !== null) {
          logGabitoEvent(gabitoEvent);
        } else {
          logNonAuthGabitoEvent(gabitoEvent);
        } // fire ga event


        gaPageView();
      }
    }
  }, [pathname, user]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};